<template lang="pug">
  .d-flex.flex-row.flex(v-if="marqueeList.length >= 1")
    marquee.flex.mr-1.flex-grow-1.font-weight-bold(behavior="scroll" direction="left" scrollamount="5") {{ marqueeList[0]['msg_' + language] }}
</template>

<script>
export default {
  data() {
    return {
      marqueeList: []
    };
  },
  computed: {
    language() {
      if(this.$store.getters.language == "zh") {
        return "cn"
      } else {
        return this.$store.getters.language
      }
    }
  },
  mounted() {
    this.getMarqueeList();
  },
  methods: {
    getMarqueeList() {
      this.marqueeList = [];
      this.$store.dispatch("message/getMarqueeList").then(res => {
        this.marqueeList = res.value;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.flex {
  flex: 1;
}
</style>
